import removeHtmlComments from "../utilities/removeHtmlComments.js";

const togglePlaceholder = (element, value) => {
    if (element.dataset.theme === 'snow') return;

    const quill = element.querySelector('.ra-quill');
    if (value === null || value === undefined) {
        value = !quill.textContent || quill.textContent === element.dataset.placeholder;
    }

    if (value) {
        element.classList.add("text-neutral-400", "italic", "text-sm");
        quill.innerHTML = element.dataset.placeholder;
    } else {
        element.classList.remove("text-neutral-400", "italic", "text-sm");
        quill.innerHTML = removeHtmlComments(quill.innerHTML);
        if (!quill.innerHTML || quill.innerHTML === element.dataset.placeholder) quill.innerHTML = '';
    }
};

export default togglePlaceholder;
